import { Component, Inject, OnInit } from '@angular/core';
import { ApiservicesService } from '../../../apiservices.service';
import { EncryptdecryptService } from '../../../services/encryptdecrypt.service';
import { APP_CONFIG, AppConfig } from '../../../app-config';

@Component({
  selector: 'app-borang-berulang',
  templateUrl: './borang-berulang.component.html',
  styleUrls: ['./borang-berulang.component.css']
})
export class BorangBerulangComponent implements OnInit {

  //Open Window
  openedWindowStatus: any = null;

  //UI Status Variables
  LoaderStatus: boolean = false;
  SearchStatus: boolean = false;
  YearAssessmentRegisterStatus = false;

  //UI View Alert Variables
  AlertType: string = "";
  AlertStatus: boolean = false;
  AlertMessage: string = "";

  //UI Input Variables
  SearchTypeInput: any = "";
  TINInput: any = "";
  AgentInput: any = "";
  FormTypeInput: any = "";
  YearAssessmentInput: any = "";
  AcknowledgementYearAssessmentInput: any = "";

  //UI View Variables
  TINView: any = "";
  ItGrpCdView: any = "";
  TaxpNameView: any = "";
  BranchNameView: any = "";

  //UI List Variables
  FormTypeList: any[] = [];
  YearAssessmentList: any[] = [];

  //Session Variables
  SessionFirmID: any = "";
  SessionStaffID: any = "";
  SessionStaffIDNo: any = "";
  SessionRoles: any = [];

  //Array Variables
  AgentList: any = new Array;

  //Datatable
  displayedColumns = ['jenisborang', 'tahun', 'action'];

  // Config property for HTML access
  integrasiCkmTitle: string = '';

  constructor(
    private apiServices: ApiservicesService, 
    private encryptDecryptService: EncryptdecryptService,
    @Inject(APP_CONFIG) private config: AppConfig
    ) {
      this.integrasiCkmTitle = config.sectionTitles.integrasiCkm;
    }

  ngOnInit(): void {
    this.SessionFirmID = this.encryptDecryptService.decrypt(sessionStorage.getItem('FirmID') || '');
    this.SessionStaffID = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffID') || '');
    this.SessionStaffIDNo = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffIDNo') || '');
    this.SessionRoles = this.encryptDecryptService.decrypt(sessionStorage.getItem('StaffRoles') || '');
  }
  onChangeIDType() {
    this.ResetValue();
  }
  ResetValue() {
    this.SearchStatus = false;
    this.YearAssessmentRegisterStatus = false;

    this.AgentInput = "";
    this.FormTypeInput = "";

    this.TINView = "";
    this.ItGrpCdView = "";
    this.TaxpNameView = "";

    this.FormTypeList = [];
    this.YearAssessmentList = [];
  }
  Semula() {
    this.LoaderStatus = false;
    this.SearchStatus = false;
    this.AlertStatus = false;
    this.YearAssessmentRegisterStatus = false;
    this.SearchTypeInput = "";
    this.TINInput = "";
    this.FormTypeInput = "";
    this.FormTypeList = [];
  }
  async Submit(SearchType: any, TIN: any) {
    this.ResetValue();
    this.LoaderStatus = true;
    if (TIN === "" || SearchType === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila masukkan butiran";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
      this.SearchStatus = false;
    } else {
      let Params = {};
      if (SearchType === "6") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "itRefNo": Number(TIN)
        };
      } else if (SearchType === "7") {
        Params = {
          "firmID": Number(this.SessionFirmID),
          "newEmplRefNo": Number(TIN)
        };
      }
      const result = await this.apiServices.FrequentFormDetail(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        this.GetAgent(this.SessionFirmID);
        this.TINView = result.taxPayer.iT_Ref_No;
        this.ItGrpCdView = result.taxPayer.jenisFail;
        this.TaxpNameView = result.taxPayer.nama;
        this.BranchNameView = result.taxPayer.namaCaw;
        result.eBorang.forEach((currentValue: any, index: any) => {
          this.FormTypeList.push(result.eBorang[index]);
        });
        this.SearchStatus = true;
        this.LoaderStatus = false;
      }
    }
  }
  async Login(FormType: any, TIN: any, AgentID: any, YearAssessment:any) {
    if (AgentID === "" || FormType === "" || TIN === "") {
      this.AlertType = "fail";
      this.AlertMessage = "Sila pilih ejen cukai";
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      let URL = "", EncUserName = "", EncClientID = "", EncTAIDNo = "", EncFirmID = "", EncPassword = "";
      let Params = {};
      switch (FormType) {
        case "CKM":
        case "BNT CKM":
          Params = {
            "firmID": Number(this.SessionFirmID),
            "itRefNo": Number(TIN),
            "staffID": Number(this.SessionStaffID),
            "taxAgentID": Number(AgentID),
            "formType": FormType
          }
          break;
        case "CP204B":
          Params = {
            "firmID": Number(this.SessionFirmID),
            "itRefNo": Number(TIN),
            "formYear": YearAssessment,
            "staffID": Number(this.SessionStaffID),
            "taxAgentID": Number(AgentID),
            "formType": FormType
          }
          break;
        case "CP22":
          Params = {
            "firmID": Number(this.SessionFirmID),
            "newEmplRefNo": Number(TIN),
            "staffID": Number(this.SessionStaffID),
            "taxAgentID": Number(AgentID),
            "formType": FormType
          }
          break;
      }
      const result = await this.apiServices.FrequentFormlogin(Params);
      if (result.hasError) {
        this.AlertType = "fail";
        this.AlertMessage = result.errMsg;
        this.AlertStatus = true;
        setTimeout(() => {
          this.AlertStatus = false;
        }, 1001);
        this.LoaderStatus = false;
        this.SearchStatus = false;
      } else {
        EncUserName = await this.EncryptDecryptText('201', this.SessionStaffIDNo);
        EncClientID = await this.EncryptDecryptText('201', TIN);
        EncTAIDNo = await this.EncryptDecryptText('201', result.taxAgentIDNo);
        EncFirmID = await this.EncryptDecryptText('201', this.SessionFirmID);
        EncPassword = await this.EncryptDecryptText('201', result.password);

        switch (FormType) {
          case "CKM":
          case "BNT CKM":
            URL = result.url + "?UserName=" + EncUserName + "&NoRujukan=" + EncClientID + "&TAIDNo=" + EncTAIDNo + "&FirmID=" + EncFirmID + "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + FormType +"&language=en-US";
            break;
          case "CP22":
            URL = result.url + "?UserName=" + EncUserName + "&NoRujukan=" + EncClientID + "&TAIDNo=" + EncTAIDNo + "&FirmID=" + EncFirmID + "&Jenis_Sijil=" + result.certType + "&JenisBorang=CP22&language=en-US";
            break;
          case "CP204B":
            let tempRoles = "";
            const Roles = JSON.parse(this.SessionRoles);
            Roles.forEach((currentValue: any, index: any) => {
              if (currentValue === "0202")
                tempRoles = "PENYELIA";
              else if (currentValue === "0203")
                tempRoles = "STAF";
              else if (currentValue === "0204")
                tempRoles = "EJEN CUKAI";
            });
            URL = result.url + "?IPAddress=&UserName=" + EncUserName + "&Password=" + EncPassword + "&FirmID=" + this.SessionFirmID +
              "&Nama=" + encodeURI(result.taxAgentName) + "&ID=" + EncTAIDNo + "&CompanyRefNo=" + EncClientID + "&Jenis_File=" + result.taxPayerFileType +
              "&Jenis_Sijil=" + result.certType + "&JenisBorang=" + result.formType + "&Roc_No=" + encodeURI(result.taxPayerROC) + "&Jawatan=" + tempRoles + "&CompanyName=" + encodeURI(result.taxPayerName) +
              "&LicenseNo=" + result.taxAgentLicenseNo + "&Asm_Yr=" + await this.EncryptDecryptText('201', YearAssessment);
            break;
        }
        this.openWindow(URL);
      }
    }
  }
  async GetAgent(FirmID: any) {
    let Params = {
      "FirmID": FirmID,
      "Role": "0204",
      "NonExpiredTaxAgent": false
    }
    const result = await this.apiServices.GetFirmStaff(Params);
    this.AgentList = result;
  }
  async GetAcknowledment(FormType: any, YearAssessment: any, TaxRefNum: any) {
    this.LoaderStatus = true;
    const result = await this.apiServices.GetAcknowledment(this.SessionFirmID, FormType, YearAssessment, TaxRefNum,"", this.SessionStaffIDNo);
    if (result.hasError) {
      this.AlertType = "fail";
      this.AlertMessage = result.errMsg;
      this.AlertStatus = true;
      setTimeout(() => {
        this.AlertStatus = false;
      }, 1001);
      this.LoaderStatus = false;
    } else {
      this.LoaderStatus = false;
      this.GoAcknowledgment(result.url, result.paramBody);
    }

  }
  GoAcknowledgment(ParamUrl: any, ParamBody: any) {

    var form = document.createElement("form");
    form.target = "Map";
    form.method = "POST";
    form.action = ParamUrl;
    for (var x = 0; x < ParamBody.length; x++) {
      var elementArr = document.createElement("input");
      elementArr.name = ParamBody[x].paramName;
      elementArr.value = ParamBody[x].paramValue;
      elementArr.type = "hidden";
      form.appendChild(elementArr);
    }
    document.body.appendChild(form);



    var map = window.open("", "Map", "");

    if (map) {
      this.LoaderStatus = false;
      form.submit();
    } else {
      alert('You must allow popups for this map to work.');
    }
  }
  async EncryptDecryptText(Type: any, Text: any) {
    let EncryptedText;
    const result = await this.apiServices.GetEncryptDecrypt(Type, Text);
    EncryptedText = JSON.parse(JSON.stringify(result));
    return EncryptedText;
  }
  ChangeFormTypeRegister(FormType: any) {
    this.YearAssessmentList = [];
    this.FormTypeList.forEach((currentValue: any, index: any) => {
      if (FormType === currentValue.formName) {
        currentValue.formYear.forEach((currentValueInner: any, indexInner: any) => {
          this.YearAssessmentList.push(currentValueInner);
        });

      }
    });
    this.YearAssessmentList.sort(function (a, b) {
      return b - a; // sort in descending order
    })
    //this.YearAssessmentList = this.YearAssessmentList.sort((a, b) => (a.nome > b.nome ? -1 : 1));
    switch (FormType) {
      case "CKM":
      case "BNT CKM":
      case "CP22":
        this.YearAssessmentRegisterStatus = false;
        break;
      default:
        this.YearAssessmentRegisterStatus = true;
        break;
    }
  }
  openWindow(URL: any) {
    if (this.openedWindowStatus === null || this.openedWindowStatus.closed)
      this.openedWindowStatus = window.open(URL, "_blank");
    else
      this.openedWindowStatus.focus();
  }
}
